// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"69":"bb26a71ccb0aa747c8a7","655":"acef68c032af24bfd8c8"}[chunkId] + ".js";
};